import { ActiveFormStateControl } from './active-form-state.control';

export class FormStateControl extends ActiveFormStateControl {
  // tslint:disable-next-line: no-empty no-any
  constructor(...args: Array<any>) {
    super(args);
  }

  public isInvalid(name: string): boolean {
    const control = this.getControl(name);

    return control.touched && control.invalid;
  }

  public markFormAsTouched(): void {
    for (const key in this.infoForm.controls) {
      if (this.infoForm.controls[key]) {
        this.infoForm.controls[key].markAsTouched();
      }
    }
  }
}
